import React from "react";
import { Divider, Container, Box } from "@mui/material";
import AboutNav from "../components/nav/AboutNav";
import Vision from "../components/aboutUs/Vision";
import Working from "../components/aboutUs/Working";
import Mission from "../components/aboutUs/Mission";
import Clients from "../components/aboutUs/Clients";
import Testimonials from "../components/aboutUs/Testimonials";

function AboutUs() {
  return (
    <>
      <AboutNav />

      <Container disableGutters={true}>
        <Vision />
        <Working />
        <Divider sx={{ color: "#D6D6D6" }} />
        <Mission />
        <Divider sx={{ color: "#D6D6D6" }} />
        <Clients />
      </Container>
      <Testimonials />
    </>
  );
}

export default AboutUs;
